'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { createMedia } from '@artsy/fresnel';
import styled from 'styled-components';
import { lgStartPixels, mdStartPixels, smStartPixels, withHoverSupport, xlStartPixels, } from '../../constants/breakpoints';
const AppMedia = createMedia({
    breakpoints: {
        xs: 0,
        sm: smStartPixels,
        md: mdStartPixels,
        lg: lgStartPixels,
        xl: xlStartPixels,
    },
});
export const MediaContextProvider = ({ disableDynamicMediaQueries = true, ...rest }) => {
    return (_jsx(AppMedia.MediaContextProvider, { disableDynamicMediaQueries: disableDynamicMediaQueries, ...rest }));
};
export const mediaStyles = AppMedia.createMediaStyle();
export const Media = AppMedia.Media;
export const MediaAsContents = styled(Media) `
  display: contents;
`;
export const MediaFeatures = styled(({ renderIfFalsy: _renderIfFalsy, feature: _feature, ...props }) => {
    return _jsx("div", { ...props });
}) `
  display: ${o => (o.renderIfFalsy ? 'contents' : 'none')};

  ${o => o.feature === 'supportsHover' &&
    `
    ${withHoverSupport} {
      display: ${o.renderIfFalsy ? 'none' : 'contents'};
    }  
  `}
`;
//# sourceMappingURL=index.js.map